import React, { Component } from 'react';
import { Button, Form, FormGroup, Label, Input } from 'reactstrap';
import '../App.css';

class LoginContainer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: ''
    }
  }

  _handleSubmit = event => {
    const { onLogin } = this.props;
    if (onLogin) {
      onLogin(this.state.email, this.state.password);
    }
    event.preventDefault();
  };

  render() {
    return (
      <div className="LoginContainer">
        <div className="LoginForm">
          <Form onSubmit={this._handleSubmit}>
            <FormGroup>
              <Label for="userEmail">Email</Label>
              <Input type="email" name="email" id="userEmail" placeholder="" onChange={(event) => this.setState({ email: event.target.value })} />
            </FormGroup>
            <FormGroup>
              <Label for="userPassword">Password</Label>
              <Input type="password" name="password" id="userPassword" placeholder="" onChange={(event) => this.setState({ password: event.target.value })} />
            </FormGroup>
            {this.props.error && (
              <div style={{ paddingBottom: 20, color: 'red' }}>Incorrect username or password</div>
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Button color="success" type="submit">Submit</Button>
              <button
                type="button"
                onClick={this.props.onForgotPassword}
                style={{ background: 'none', border: 'none', padding: 0, color: '#0d6efd', cursor: 'pointer', fontSize: '1rem' }}
              >
                Forgot Password
              </button>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

export default LoginContainer;
